import React from 'react';
import { portalCopy } from '../copy';
import type { WeekHours } from '../types';

const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;

type BusinessHoursReadOnlyProps = {
  hours: WeekHours;
};

const BusinessHoursReadOnly: React.FC<BusinessHoursReadOnlyProps> = ({ hours }) => (
  <div className="space-y-2">
    {DAY_KEYS.map((day) => (
      <div
        key={day}
        className="flex items-center justify-between gap-4 rounded-xl bg-[#fcf7fa] px-3 py-2.5"
      >
        <span className="font-jakarta text-sm font-medium text-[#2a0f2a]">
          {portalCopy.wizard.profile.days[day]}
        </span>
        <span className="font-jakarta text-sm text-[#5a3158]">
          {hours[day].open
            ? `${hours[day].from} – ${hours[day].to}`
            : portalCopy.wizard.profile.closed}
        </span>
      </div>
    ))}
  </div>
);

export default BusinessHoursReadOnly;
